import type { FlowNodeType } from '@reflex/flows';
import { cn } from '@reflex/ui/lib/utils';
import { FlowNodeTypeIcon } from './FlowNodeIcons';
import { FLOW_NODE_LABELS, FLOW_NODE_THEME } from './flow-node-theme';

interface FlowNodeTagProps {
  type: FlowNodeType;
  /** Extra qualifier after a mid-dot, e.g. Trigger · Event. */
  subtype?: string;
  className?: string;
}

/**
 * Type-colored pill that sits at the top of a canvas node card.
 * Colors and 12px glyph match the Figma Node tag component.
 */
export function FlowNodeTag({ type, subtype, className }: FlowNodeTagProps) {
  const theme = FLOW_NODE_THEME[type];
  return (
    <div
      className={cn(
        'inline-flex h-6 w-fit max-w-full shrink-0 items-center gap-2 self-start overflow-hidden rounded-2xl px-2',
        theme.tag,
        className,
      )}
      data-testid="flow-node-tag"
      data-node-type={type}
    >
      <FlowNodeTypeIcon type={type} className="size-3 shrink-0" />
      <span className="truncate text-xs font-semibold leading-[17px]">
        {FLOW_NODE_LABELS[type]}
      </span>
      {subtype ? (
        <span className="inline-flex min-w-0 items-center gap-1">
          <span className="size-0.5 shrink-0 rounded-full bg-current" aria-hidden="true" />
          <span className="truncate text-xs font-semibold leading-[17px]">{subtype}</span>
        </span>
      ) : null}
    </div>
  );
}
